// extracted by mini-css-extract-plugin
module.exports = {"new-reservation-button":"style_new-reservation-button__xz_IB","new-reservation-text":"style_new-reservation-text__2DMDj","new-reservation-plus":"style_new-reservation-plus__1u_Vc"};